import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import used_machine_tools from '~/images/machine-categories/used_machine_tools.png';
import sheet_metal from '~/images/machine-categories/sheet_metal.png';
import injection_moulding from '~/images/machine-categories/injection_moulding.png';
import robot from '~/images/machine-categories/robot.png';
import wood from '~/images/machine-categories/WW.png';
import Image from 'next/image';
import CoorpLayout, { Title, Text } from '@/components/layout/CoorpLayout';
import { Link } from 'next-translate-routes-multi-domain';

export default function MachineCategoriesPage() {
  const { t } = useTranslation('products');

  return (
    <CoorpLayout
      headingOne={t('products:CORPORATE_MACHINE_CATEGORIES_H1')}
      headingTwo={t('products:CORPORATE_MACHINE_CATEGORIES_H2')}
      headingThree={t('products:CORPORATE_MACHINE_CATEGORIES_H3_HERO')}
      breadcrubPages={[
        {
          name: t('products:CORPORATE_MACHINE_CATEGORIES_H1'),
          href: '/machine-categories',
        },
      ]}
    >
      <Title title={t('products:CORPORATE_MACHINE_CATEGORIES_TITLE')} />
      <Text text={t('products:CORPORATE_MACHINE_CATEGORIES_P1')} />
      <MachineType
        imgSrc={used_machine_tools}
        imgAlt={t('products:CORPORATE_MACHINE_CATEGORIES_ALT')}
        title={t('products:MACHINE_TOOLS_NAME')}
        text={t('products:CORPORATE_MACHINE_CATEGORIES_ITEM_1_TEXT')}
        linkUrl={'/products/used-machine-tools'}
        linkName={t('products:CORPORATE_MACHINE_TOOLS_LINK')}
        sellingLinkUrl={'/selling-process'}
        sellingLinkName={t('products:CORPORATE_MACHINE_TOOLS_SELLING_LINK')}
      />
      <MachineType
        imgSrc={sheet_metal}
        imgAlt={t('products:CORPORATE_MACHINE_CATEGORIES_ALT')}
        title={t('products:SHEET_METAL_NAME')}
        text={t('products:CORPORATE_MACHINE_CATEGORIES_ITEM_2_TEXT')}
        linkUrl={'/products/used-sheet-metal-machinery'}
        linkName={t('products:CORPORATE_SHEET_METAL_LINK')}
        sellingLinkUrl={'/selling-process'}
        sellingLinkName={t('products:CORPORATE_SHEET_METAL_SELLING_LINK')}
      />
      <MachineType
        imgSrc={injection_moulding}
        imgAlt={t('products:CORPORATE_MACHINE_CATEGORIES_ALT')}
        title={t('products:PLASTICS_PROCESSING_NAME')}
        text={t(
          'products:CORPORATE_MACHINE_CATEGORIES_ITEM_3_TEXT_PLASTICS_PROCESSING'
        )}
        linkUrl={'/products/used-plastics-processing-machinery'}
        linkName={t('products:CORPORATE_PLASTICS_PROCESSING_LINK')}
        sellingLinkUrl={'/selling-process'}
        sellingLinkName={t(
          'products:CORPORATE_PLASTICS_PROCESSING_SELLING_LINK'
        )}
      />
      <MachineType
        imgSrc={robot}
        imgAlt={t('products:CORPORATE_MACHINE_CATEGORIES_ALT')}
        title={t('products:AUTOMATION_EQUIPMENT_NAME')}
        text={t('products:CORPORATE_MACHINE_CATEGORIES_ITEM_4_TEXT')}
        linkUrl={'/products/used-automation-equipment'}
        linkName={t('products:CORPORATE_AUTOMATION_EQUIPMENT_LINK')}
        sellingLinkUrl={'/selling-process'}
        sellingLinkName={t(
          'products:CORPORATE_AUTOMATION_EQUIPMENT_SELLING_LINK'
        )}
      />
      <MachineType
        imgSrc={wood}
        imgAlt={t('products:CORPORATE_MACHINE_CATEGORIES_ALT')}
        title={t('products:CATEGORY_PAGE_WOODMACHINERY')}
        text={t('products:CATEGORY_PAGE_WOODWORKING_DESCRIPTION')}
        linkUrl={'/products/used-wood-working-machinery'}
        linkName={t('products:CATEGORY_PAGE_WOODWORKING_LINK')}
        sellingLinkUrl={'/selling-process'}
        sellingLinkName={t('products:CATEGORY_PAGE_WOODWORKING_LINK_SELL')}
      />
    </CoorpLayout>
  );
}

function MachineType({
  imgSrc,
  imgAlt,
  title,
  text,
  linkUrl,
  linkName,
  sellingLinkUrl,
  sellingLinkName,
}: {
  imgSrc: any;
  imgAlt: string;
  title: string;
  text: string;
  linkUrl: string;
  linkName: string;
  sellingLinkUrl: string;
  sellingLinkName: string;
}) {
  return (
    <div className='mt-4 grid w-full grid-cols-1 justify-start gap-16 pb-16 pt-8 md:grid-cols-2'>
      {/* TODO: SEO, alt doesn't exists in translations */}
      <div className='relative flex shrink-0 items-center justify-center overflow-hidden rounded'>
        <Image src={imgSrc} alt={imgAlt} className='aspec-1 ' />
      </div>
      <div>
        <Title isLeft hasDivider={false} title={title} />
        <Text isLeft text={text} />
        <div className='grid grid-cols-1 pt-5'>
          <Link href={linkUrl}>
            <a className='text-lg font-semibold text-[#4d4d4d]'>{linkName}</a>
          </Link>
          <Link href={sellingLinkUrl}>
            <a className='text-lg font-semibold text-[#4d4d4d]'>
              {sellingLinkName}
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
}
